
<template>
    
        <mars-view class="bottom-btn-container"><mars-view class="law-bottom"><free-reserve-bottom-exp-new :consult-count="onlioneConsultants" :compatible-safarea="compatibleSafarea" :lawyer-group-name="lawyerGroupName" :from="isH5 ? 'lvlinqg_bottom_form_h5' : 'lvlinqg_bottom_form_swan'" :font-size-setting="fontSizeSetting" :title="question.title" @turnReserve="turnReserve"></free-reserve-bottom-exp-new></mars-view><clue-collection-popup v-if="showPopup" :show="showPopup" :params="{addressType: 'qa-bottom-right'}" :from="isH5 ? 'lvlinqg_bottom_form_h5' : 'lvlinqg_bottom_form_swan'" :law-clue-config-image-url="lawClueConfigImageUrl" :nqid="question.encode_qid" @closeEvent="closeClueCollectionPopup"></clue-collection-popup></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */
import freeReserveBottomExpNew from "../../../pages/qalandpage/components/freeReserveBottomExpNew.vue";
import clueCollectionPopup from "../../../components/common/clueCollectionPopup.vue";
export default {
  components: {
    'free-reserve-bottom-exp-new': freeReserveBottomExpNew,
    'clue-collection-popup': clueCollectionPopup
  },
  props: {
    // 问题相关数据
    question: {
      type: Object,
      default() {
        return {};
      }
    },
    lawClueConfigImageUrl: {
      type: String,
      default: ''
    },
    // 在线咨询人数
    onlioneConsultants: {
      type: Number,
      default: 0
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  },
  computed: {
    lawyerGroupName() {
      return this.question && this.question.lawyerGroupName || '';
    },
    // 底部按钮实验
    isTest() {
      let lawExpTags = getApp().globalData.lawExpTags || {};
      return lawExpTags.law_dibuanniu_ue && +lawExpTags.law_dibuanniu_ue.data === 1;
    }
  },
  data() {
    return {
      compatibleSafarea: false,
      showPopup: false,
      isH5: "h5" === 'h5'
    };
  },
  mounted() {
    this.isNeedSafeArea();
  },
  methods: {
    // 获取手机类型
    isNeedSafeArea() {},
    closeClueCollectionPopup() {
      this.showPopup = false;
    },
    // 线上咨询
    turnIm(type = '') {
      window.location.href = `https://wen.baidu.com/pages/main/index/ask?fr=pay_zd_h5LvliniknowQabdx_order&word=${encodeURIComponent(this.question && this.question.title || '')}`;
    },
    turnReserve(type) {
      if (type === 'bot') {
        this.$emit('turnReserve');
        return;
      }
      this.showPopup = true;
    }
  }
};
</script>

<style scoped>
.bottom-btn-container .law-bottom {
  height: 0.5rem;
  margin-top: 0.09rem;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.bottom-btn-container .law-bottom /deep/ .message {
  background-image: linear-gradient(90deg, #fd503e 1%, #ff4060 100%) !important;
}
.bottom-btn-container .law-bottom [class*='__message'] {
  background-image: linear-gradient(90deg, #fd503e 1%, #ff4060 100%) !important;
}
.bottom-btn-container .law-bottom /deep/ .consulting {
  border: 1px solid #dddddd !important;
  color: #525252 !important;
}
.bottom-btn-container .law-bottom [class*='__consulting'] {
  border: 1px solid #dddddd !important;
  color: #525252 !important;
}
.bottom-btn-container .law-bottom .bottom-line {
  height: 1px;
  background: #eee;
  transform: scaleY(0.5);
}
.bottom-btn-container .law-bottom .btn-area {
  height: 14.0097vw;
  padding-left: 3.3816vw;
  padding-right: 3.3816vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom-btn-container .law-bottom .btn-area .free-order-btn {
  box-sizing: border-box;
  width: 26.57vw;
  height: 11.59vw;
  border: 1px solid #ddd;
  border-radius: 5.8vw;
  font-family: PingFang SC;
  font-size: 4.35vw;
  color: #525252;
  letter-spacing: 0;
  text-align: center;
  line-height: 11.59vw;
  margin-right: 10px;
}
.bottom-btn-container .law-bottom .btn-area .order-btn {
  flex-shrink: 0;
  font-size: 13px;
  color: #222;
  line-height: 13px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 7.0048vw;
}
.bottom-btn-container .law-bottom .btn-area .order-btn .order-icon {
  width: 4.1063vw;
  height: 4.1063vw;
  margin-bottom: 0.9662vw;
  background: url('https://iknow-pic.cdn.bcebos.com/b90e7bec54e736d121e5d89a89504fc2d46269a9?x-bce-process=image/quality,q_80') no-repeat;
  background-size: contain;
}
.bottom-btn-container .law-bottom .btn-area .bottom-btn {
  flex-grow: 1;
  height: 11.5942vw;
  background-image: linear-gradient(90deg, #fd503e 1%, #ff4060 100%) !important;
  border-radius: 5.7971vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bottom-btn-container .law-bottom .bottom-btn .btn-text {
  font-size: 4.3478vw;
  line-height: 4.3478vw;
  color: #fff;
  margin-bottom: 0.7246vw;
  font-weight: 600;
}
.bottom-btn-container .law-bottom .bottom-btn .btn-count {
  font-size: 2.8986vw;
  line-height: 2.8986vw;
  color: #fff;
  opacity: 0.8;
}

</style>
